module.exports = __webpack_public_path__ + "img/World2016.c533d8e0.png";